import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, MenuItem, FormControlLabel } from '@material-ui/core';
import { isEmpty } from 'lodash';
import OutlinedSelect from '../../../../controls/OutlinedSelect';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';

const styles = (theme) => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    fieldLabel: {
        marginTop: theme.spacing(2),
        color: grey[600],
    },
    grey: {
        color: grey[600],
    },
    queryParamsDiv: {
        padding: theme.spacing(0.5, 0, 1, 0),
        display: 'flex',
    },
    choice: {
        '&:hover': {
            backgroundColor: 'rgb(189, 189, 189, 0.1)',
        },
        '&:hover $dragIcon': {
            visibility: 'visible',
        },
    },
    choiceIcon: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    drag: {
        backgroundColor: 'rgb(189, 189, 189, 0.1)',
        '&:active $dragIcon': {
            visibility: 'visible',
        },
    },
    dragIcon: {
        visibility: 'hidden',
        height: 'auto',
    },
    queryParams: {
        backgroundColor: 'white',
        margin: theme.spacing(0, 2),
        display: 'flex',
    },
    control: {
        backgroundColor: '#ffffff',
        margin: theme.spacing(0, 1),
    },
    applyTextEllipsis: {
        whiteSpace: 'nowrap',
        width: 'calc(100% - 3rem)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    removeTextEllipsis: {
        whiteSpace: 'unset',
        width: 'initial',
        overflow: 'unset',
        textOverflow: 'unset',
    },
});
const newQueryParamObject = { queryParamType: '', queryParamValue: '' };

const urlOptions = [
    { title: 'Coded Value', value: 'codedValues' },
    { title: 'Inspection Type', value: 'inspectionTypes' },
    { title: 'User Profile', value: 'userProfiles' },
    { title: 'Violation Category', value: 'violationCategories' },
];

class ChoicesFromApi extends Component {
    state = {
        isTemplateUrl: false,
        fieldOptions: [],
    };

    componentDidMount() {
        this.setState({
            isTemplateUrl: typeof this.props.api.url === 'object' && this.props.api.url.template,
            fieldOptions: this.props.factFields.filter((fact) => !isEmpty(fact)).map((fact) => fact.field),
        });
    }

    handleChangeUrlForApi = (newUrl) => {
        const urlResource = typeof this.props.api.url === 'string' ? this.props.api.url.split('/')[0] : undefined;
        const codedValueType = urlResource === 'codedValues' ? this.props.api.url.split('/')[1] : '';
        let selectedUrl = '';

        if (newUrl) {
            if (newUrl?.value) {
                if (newUrl.value === 'codedValues') {
                    selectedUrl = codedValueType !== '' ? newUrl.value + '/' + codedValueType : `${newUrl.value}/`;
                } else {
                    selectedUrl = newUrl.value;
                }
            } else if (this.state.isTemplateUrl) {
                selectedUrl = { ...this.props.api.url, template: newUrl };
            } else {
                selectedUrl = newUrl;
            }
        }

        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    handleChangeCodedValueTypeForApi = (codedValueElement) => {
        const codedValueType = codedValueElement.target.value;
        const url = this.props.api.url.split('/')[0];
        const selectedUrl = url + '/' + codedValueType;
        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    handleAddQueryParamForApi = (index) => {
        const action = 'add';
        this.onQueryParamsChangeForApi(index, newQueryParamObject, action);
    };

    handleDeleteQueryParamForApi = (index) => {
        this.onQueryParamsChangeForApi(index);
    };

    handleChangeQueryParamsForApi = (index, newQueryParam, changeType) => {
        const queryParamObject =
            changeType === 'type'
                ? { ...this.props.api.queryParamsArray[index], queryParamType: newQueryParam }
                : { ...this.props.api.queryParamsArray[index], queryParamValue: newQueryParam };
        const action = 'change';
        this.onQueryParamsChangeForApi(index, queryParamObject, action);
    };

    onQueryParamsChangeForApi = (index, value, action) => {
        const prevQueryParams = this.props.api.queryParamsArray;
        let newQueryParams;
        if (value && action === 'change') {
            newQueryParams = [...prevQueryParams.slice(0, index), value, ...prevQueryParams.slice(index + 1)];
        } else if (value && action === 'add') {
            newQueryParams = [...prevQueryParams.slice(0, index + 1), value, ...prevQueryParams.slice(index + 1)];
        } else {
            if (prevQueryParams.length === 1) {
                newQueryParams = [newQueryParamObject];
            } else {
                newQueryParams = prevQueryParams.filter((queryParam, queryParamIndex) => queryParamIndex !== index);
            }
        }
        this.props.onApiChange({ id: 'queryParams', updatedQueryParams: newQueryParams });
    };

    handleResultMappingChangeForApi = (event) => {
        const resultMappingValue = event.target.value;
        this.props.onApiChange({ id: 'resultMappingValue', resultMappingValue: resultMappingValue });
    };

    handleChangeQueryParamsForApi = (index, newQueryParam, changeType) => {
        let queryParamObject;
        if (changeType === 'value') {
            const value = this.state.fieldOptions.includes(newQueryParam)
                ? { fact: newQueryParam }
                : !newQueryParam
                ? null
                : newQueryParam;
            queryParamObject = { ...this.props.api.queryParamsArray[index], queryParamValue: value };
        } else if (changeType === 'type') {
            queryParamObject = { ...this.props.api.queryParamsArray[index], queryParamType: newQueryParam };
        }
        const action = 'change';
        this.onQueryParamsChangeForApi(index, queryParamObject, action);
    };

    handleIsTemplateUrl = (event) => {
        this.setState({ isTemplateUrl: event.target.checked });
        this.props.onApiChange({ id: 'url', updatedUrl: '' });
    };

    handleChangeTemplateUrlVariablesForApi = (oldVariable, newVariable) => {
        const urlVariablesCopy = Object.assign({}, this.props.api.url.variables);
        delete Object.assign(urlVariablesCopy, {
            [newVariable]: urlVariablesCopy[oldVariable],
        })[oldVariable];
        const selectedUrl = { ...this.props.api.url, variables: urlVariablesCopy };
        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    handleChangeTemplateUrlVariableValueForApi = (variable, value) => {
        const urlVariablesCopy = Object.assign({}, this.props.api.url.variables);
        const variablesNew = Object.assign(urlVariablesCopy, {
            [variable]: value,
        });
        const selectedUrl = {
            ...this.props.api.url,
            variables: variablesNew,
        };
        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    handleAddVariableForApi = () => {
        const selectedUrl = { ...this.props.api.url, variables: { ...this.props.api.url.variables, '': '' } };
        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    handleDeleteVariableForApi = (variable) => {
        const urlVariablesCopy = Object.assign({}, this.props.api.url.variables);
        delete urlVariablesCopy[variable];
        const selectedUrl = { ...this.props.api.url, variables: urlVariablesCopy };
        this.props.onApiChange({ id: 'url', updatedUrl: selectedUrl });
    };

    render() {
        const { classes } = this.props;

        const queryParamsArray = this.props.formatQueryParamsForApi(
            this.props.api.queryParamsArray ?? this.props.api.queryParams,
        );

        const labelClasses = {
            outlined: classes.applyTextEllipsis,
            shrink: classes.removeTextEllipsis,
        };

        const url =
            typeof this.props.api.url === 'string' && this.props.api.url.split('/')[0] !== undefined
                ? this.props.api.url.split('/')[0]
                : '';
        const codedValueType =
            url === 'codedValues' && this.props.api.url.split('/')[1] !== undefined
                ? this.props.api.url.split('/')[1]
                : '';

        const selectedUrlType = urlOptions.filter((option) => option.value === url)[0];

        return (
            <Grid item xs={12}>
                <Typography className={classes.grey} variant="subtitle2" gutterBottom>
                    URL
                </Typography>
                <Grid item xs={12}>
                    <FormControlLabel
                        label={<Typography className={this.props.classes.grey}>Use Template URL</Typography>}
                        control={
                            <Checkbox
                                id={'isTemplateUrl'}
                                name={'isTemplateUrl'}
                                checked={this.state.isTemplateUrl}
                                key={'isTempalteUrl'}
                                color={'primary'}
                                className={this.props.classes.checkbox}
                                onChange={(e) => this.handleIsTemplateUrl(e)}
                            />
                        }
                    />
                </Grid>
                {!this.state.isTemplateUrl && (
                    <Grid item xs={12}>
                        <Autocomplete
                            freeSolo
                            id="url"
                            className={classes.whiteBackground}
                            aria-controls="url"
                            value={selectedUrlType ?? this.props.api.url}
                            options={urlOptions}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') {
                                    return option;
                                }
                                return option.title;
                            }}
                            onChange={(event, value) => this.handleChangeUrlForApi(value)}
                            onInputChange={(event, value, reason) => {
                                if (reason === 'input') {
                                    this.handleChangeUrlForApi(value);
                                }
                            }}
                            renderOption={(option) => option.title}
                            renderInput={(params) => <TextField {...params} placeholder="URL" variant="outlined" />}
                        />
                    </Grid>
                )}
                {url === 'codedValues' && (
                    <Grid item xs={12}>
                        <TextField
                            id="codedValueType"
                            label="Coded Value Type"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={classes.whiteBackground}
                            value={codedValueType}
                            onChange={this.handleChangeCodedValueTypeForApi}
                        />
                    </Grid>
                )}
                {this.state.isTemplateUrl && (
                    <Grid item xs={12}>
                        <TextField
                            id="templateUrl"
                            label="Template"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={classes.whiteBackground}
                            value={this.props.api.url.template}
                            onChange={(e) => this.handleChangeUrlForApi(e.target.value)}
                        />
                    </Grid>
                )}
                {this.state.isTemplateUrl && (
                    <Grid item xs={12}>
                        {Object.keys(this.props.api.url.variables ?? { '': '' }).map((variable, index) => (
                            <div key={index} className={classes.queryParamsDiv}>
                                <TextField
                                    id={'apiVariable' + index}
                                    fullWidth
                                    variant="outlined"
                                    value={variable}
                                    label="Variable"
                                    className={classes.whiteBackground}
                                    onChange={(event) =>
                                        this.handleChangeTemplateUrlVariablesForApi(variable, event.target.value)
                                    }
                                />
                                <Autocomplete
                                    autoSelect
                                    fullWidth
                                    freeSolo
                                    id={'variableValue' + index}
                                    value={variable ? this.props.api.url.variables[variable] : ''}
                                    className={classes.queryParams}
                                    options={this.state.fieldOptions}
                                    onChange={(event, newValue) => {
                                        this.handleChangeTemplateUrlVariableValueForApi(variable, newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Value" size="medium" variant="outlined" />
                                    )}
                                />
                                <Tooltip title="Add" aria-label="add choice">
                                    <IconButton
                                        onClick={() => this.handleAddVariableForApi()}
                                        size="small"
                                        className={classes.choiceIcon}
                                    >
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete" aria-label="delete choice">
                                    <IconButton
                                        onClick={() => this.handleDeleteVariableForApi(variable)}
                                        size="small"
                                        className={classes.choiceIcon}
                                    >
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        ))}
                    </Grid>
                )}
                <Typography className={classes.fieldLabel} variant="subtitle2">
                    Query Parameter
                </Typography>
                <Grid item xs={12}>
                    {queryParamsArray &&
                        queryParamsArray.length > 0 &&
                        queryParamsArray.map((choice, index) => (
                            <div key={index} className={classes.queryParamsDiv}>
                                <TextField
                                    id={'queryParamType' + index}
                                    fullWidth
                                    variant="outlined"
                                    value={choice.queryParamType}
                                    label="Type"
                                    className={classes.whiteBackground}
                                    onChange={(event) =>
                                        this.handleChangeQueryParamsForApi(index, event.target.value, 'type')
                                    }
                                />
                                <Autocomplete
                                    autoSelect
                                    fullWidth
                                    freeSolo
                                    id={'queryParamValue' + index}
                                    value={
                                        choice.queryParamValue?.fact
                                            ? choice.queryParamValue.fact
                                            : choice.queryParamValue
                                    }
                                    className={classes.queryParams}
                                    options={this.state.fieldOptions}
                                    onChange={(event, newValue) => {
                                        this.handleChangeQueryParamsForApi(index, newValue, 'value');
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Value" size="medium" variant="outlined" />
                                    )}
                                />
                                <Tooltip title="Add" aria-label="add choice">
                                    <IconButton
                                        onClick={() => this.handleAddQueryParamForApi(index)}
                                        size="small"
                                        className={classes.choiceIcon}
                                    >
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete" aria-label="delete choice">
                                    <IconButton
                                        onClick={() => this.handleDeleteQueryParamForApi(index)}
                                        size="small"
                                        className={classes.choiceIcon}
                                    >
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        ))}
                </Grid>
                <Typography className={classes.fieldLabel} variant="subtitle2">
                    Result Mapping
                </Typography>
                <Grid xs={12} item className={classes.queryParamsDiv}>
                    <Grid item xs={3}>
                        <TextField
                            id="resultMapping-value"
                            fullWidth
                            variant="outlined"
                            label="Value"
                            disabled
                            value={this.props.api.resultMapping.value}
                            className={classes.whiteBackground}
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <OutlinedSelect
                            name="Label"
                            fullWidth
                            className={classes.control}
                            labelClasses={labelClasses}
                            value={this.props.api.resultMapping.label}
                            onChange={this.handleResultMappingChangeForApi}
                        >
                            <MenuItem value="label">Label</MenuItem>
                            <MenuItem value="name">Name</MenuItem>
                        </OutlinedSelect>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(ChoicesFromApi);
